import { ReactNode } from "react";
import { ModalComponent } from "..";
import { ButtonVariations } from "../../buttons/button";

export const ConfirmationModal = ({
  isModalOpen,
  onModalClose,
  title,
  children,
  subtitle,
  onProceed,
  loading,
  proceedButtonText = "Yes, I consent",
  cancelButtonText = "No, Cancel",
  proceedButtonVariant = "primary",
  cancelButtonVariant = "danger",
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  title?: ReactNode;
  children?: ReactNode;
  subtitle?: ReactNode;
  onProceed?: () => void;
  loading?: boolean;
  proceedButtonText?: string;
  cancelButtonText?: string;
  proceedButtonVariant?: ButtonVariations;
  cancelButtonVariant?: ButtonVariations;
}) => {
  return (
    <ModalComponent
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      title={title}
      topTitle={false}
      subTitle={subtitle}
      modalClassName="!max-h-[360px"
      hasButtons
      proceedButtonText={proceedButtonText}
      proceedButtonVariant={proceedButtonVariant}
      onProceedClick={onProceed}
      hasCancelButton
      cancelButtonText={cancelButtonText}
      cancelButtonVariant={cancelButtonVariant}
      onCancelClick={() => {
        onModalClose();
      }}
      isLoading={loading}
      isProceedDisabled={loading}
    >
      {children && children}
    </ModalComponent>
  );
};
